import type { Capability } from '@taler/api-client'

/**
 * The contract has no export-specific capability: an export is a CSV of the journal, so
 * it is gated on the same view access as the journal itself, never re-derived from role.
 */
export function canViewExports(can: (capability: Capability) => boolean): boolean {
  return can('ENTRY_VIEW_ALL') || can('ENTRY_VIEW_OWN')
}

/**
 * Restore always creates a brand-new ledger owned by the caller, regardless of any role on the
 * *currently active* ledger. Checking `session.can` (keyed to the active ledger) would wrongly
 * show this to a PARTNER/CONTRIBUTOR/OBSERVER of that ledger and wrongly hide it from an OWNER
 * elsewhere - same reasoning as self-signup: anyone signed in may create a ledger, so being
 * signed in is the whole gate.
 */
export function canRestoreBackup(isSignedIn: boolean): boolean {
  return isSignedIn
}
